<template>
	<section class="ticket_index">
		<Nav title="优惠券" />
		<div class="fff" v-if="isData"></div>
		<section v-if="isData==1" class="list">
			<van-list v-model="loading" :immediate-check="false" :finished="finished" finished-text="" @load="loadMore">
				<div class="item" v-for="(item, i) in list" :key="item.id">
					<div class="item_info">
						<img src="../../../assets/img/ticket_bg_a.png" class="bg">
						<div class="left">
							<div class="left_info">
								<div v-if="item.couponType == 0"><p>{{item.couponDenomination}}</p><span>币</span></div>
								<div v-else-if="item.couponType == 1"><p>{{item.couponDenomination/100}}</p><span>元</span></div>
								<div v-else-if="item.couponType == 2"><p>{{(item.couponDenomination*10).toFixed(1)}}</p><span>折</span></div>
								<i v-if="item.couponType == 0"></i>
								<i v-else>充值满{{item.minAmount/100}}元可用</i>
							</div>
						</div>
						<div class="right">
							<h3>{{item.couponName}}</h3>
							<p class="time">{{item.useEndTime}}到期</p>
							<p class="rule_btn" @click="showRuleInfo(i)">
								使用规则
								<img src="../../../assets/img/ticket_down.png" v-if="!item.show">
								<img src="../../../assets/img/ticket_up.png" v-else>
							</p>
							<p class="select_itme" @click="skipFull(item.couponType,item.id, item.couponDenomination)">立即使用</p>
						</div>
					</div>
					
					<div class="rule_info" v-if="item.show">
						<p v-for="ruleT in item.couponRuleList" :key="ruleT">{{ruleT}}</p>
					</div>
				</div>
			</van-list>
			<p class="history" @click="skipHistory">优惠券历史记录<img src="../../../assets/img/ticket_right.png"></p>
		</section>
		<section v-else-if="isData==2" class="nodata_class">
			<div class="no_data">
				<img src="../../../assets/img/ticket_nodata.png">
				<p>暂无可用优惠券</p>
				<h4 @click="skipView">去领券中心</h4>
			</div>
			<div class="history" @click="skipHistory">优惠券历史记录<img src="../../../assets/img/ticket_right.png"></div>
		</section>
		<section v-else></section>
	</section>
</template>

<script>
import Nav from "components/Nav"
import ticketServer from "api/ticket";
import { Notify,Dialog } from 'vant';

export default {
	name: 'ticket-index',
	components: {
		Nav,
	},
	data() {
		return {
			loading: false,
			finished: false,
			list: [],
			isData: 0,
			params: {
				pageNum: 0,
				pageSize: 20,
				history: 0,
			},
		}
	},
	created() {
		this.token = localStorage.getItem('token')||''
		if(!this.token) {
			this.isData=2
			return
		}
		this.loadMore()
	},
	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},
	methods: {
		loadMore() {
			this.loading = true
			this.params.pageNum++
			ticketServer.SearchMyTicket(this.params).then((res) => {
				if(this.params.pageNum == 1) {
					if(!res.data.list || res.data.list.length==0) {
						this.isData = 2
						return
					}
				}
				res.data.list.forEach((item) => {
					item.show = 0
					item.couponRuleList = item.couponRule.split('#').filter((x) => x !== '');
				})
				this.list = this.list.concat(res.data.list) 
				this.loading = false
				this.isData = 1
				if(res.data.list.length<20) {
					this.finished = true
				}
			})
		},
		showRuleInfo(i) {
			if(this.list[i].show) {
				this.list[i].show = 0
			}else {
				this.list[i].show = 1
			}
			
		},
		skipView() {
			this.$router.push({name: 'ticket-get'})
		},
		skipHistory() {
			if(!this.token) {
				this.showloginModel()
				return
			}
			this.$router.push({name: 'ticket-history'})
		},
		showloginModel() {
			Dialog.confirm({
				title: '提示',
				message: '抢单模式已停止。现变更为推单模式。如需开通推送账户，请扫码添加客服开通。',
				confirmButtonText: '联系客服',
				cancelButtonText: '确认',
			}).then(() => {
				this.$router.push({ name: 'kefu' })
			}).catch(() => {
				// 点击"确认"，仅关闭弹窗，终止后续流程
			})
		},
		ceshi() {
			this.$router.push({name: 'ticket-get'})
		},
		skipFull(type, id, num) {
			if(type==0) {
				ticketServer.GetKuaikeTicket({userCouponId: id}).then((res) => {
					Dialog.confirm({ 
						title: '兑换成功', 
						message: `${num}展业币已充值到\n 展业币余额账户中`, 
						confirmButtonText: '去查看',
						cancelButtonText: '确定',
					}).then(() => { 
						this.$router.push({name: 'user'})
					}).catch(() => {
						this.params.pageNum = 0
						this.loadMore()
					});
				})
				
			}else {
				this.$router.push({name: 'full', query:{tickeid: id}})
			}
		}
	}
}
</script>

<style lang="scss">
	.ticket_index {
		img {
			display: block;
		}
		padding-top: 46px;
		.fff {
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: #fff;
			z-index: -1;
		}
		.list {
			padding: 19px 18px;
			.history {
				display: flex;
				justify-content: center;
				align-items: center;
				color: #7D8290;
				font-size: 14px;
				padding: 4px 0;
				img {
					width: 7px;
					margin-left: 5px;
				}
			}
			.item {
				position: relative;
				margin-bottom: 24px;

				.rule_info {
					width: 100%;
					margin-top: -5px;
					padding: 8px 11px;
					padding-top: 14px;
					border: 1Px solid #7E92E2;
					border-radius: 4px;
					border-top-left-radius: 0;
					border-top-right-radius: 0;
					border-top: 0;
					p {
						font-size: 12px;
						color: #7D8290;
					}
				}
			}
			.item_info {
				position: relative;
				width: 100%;
				height: 102px;
				.bg {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
				}
				.left {
					position: absolute;
					width: 108px;
					height: 100%;
					top: 0;
					left: 0;
					z-index: 2;
					.left_info {
						position: absolute;
						top: 50%;
						left: 50%;
						width: 100%;
						transform: translate(-50%, -50%);
						div {
							text-align: center;
							p {
								display: inline-block;
								font-size: 28px;
								font-weight: bold;
								color: #3A5EEC;
							}
							span {
								display: inline-block;
								color: #3A5EEC;
								font-weight: bold;
								font-size: 12px;
								vertical-align: text-bottom;
							}
						}
						i {
							display: block;
							text-align: center;
							font-style: normal;
							font-size: 12px;
							color: #3A5EEC;
							transform: scale(.9);
						}
					}
				}
				.right {
					position: absolute;
					height: 100%;
					width: 231px;
					top: 0;
					left: 108px;
					z-index: 2;
					padding-top: 15px;
					padding-left: 12px;
					padding-bottom: 9px;
					h3 {
						font-size: 14px;
						color: #2B2F3A;
						font-weight: bold;
					}
					.time {
						color: #A2A6AE;
						font-size: 12px;
					}
					.rule_btn {
						margin-top: 20px;
						padding-top: 6px;
						color: #A2A6AE;
						font-size: 12px;
						display: flex;
						align-items: center;
						img {
							width: 10px;
							margin-left: 2px;
						}
					}
					.select_itme {
						position: absolute;
						right: 9px;
						bottom: 9px;
						width: 70px;
						height: 26px;
						line-height: 26px;
						text-align: center;
						color: #fff;
						font-size: 12px;
						background: #3A5EEC;
						border-radius: 20px;
					}


					// <h3>新人专享福利-加币券</h3>
					// 	<p class="time">2021.11.11-2021.11.14</p>
					// 	<p class="rule_btn">
					// 		使用规则
					// 		<img src="../../../assets/img/ticket_down.png">
					// 		<!-- <img src="../../../assets/img/ticket_up.png"> -->
					// 	</p>
					// 	<p class="select_itme">立即使用</p>

				}

			}
		}
		.nodata_class {
			.no_data {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				img {
				width: 92px;
				margin: 0 auto;
			}
				p {
					color: #7D8290;
					font-size: 14px;
					text-align: center;
					padding-top: 11px;
					padding-bottom: 41px;
				}
				h4 {
					width: 127px;
					height: 36px;
					line-height: 36px;
					text-align: center;
					color: #fff;
					font-size: 14px;
					font-weight: bold;
					border-radius: 20px;
					background: #3A5EEC;
				}
			}
			.history {
				position: fixed;
				bottom: 0;
				left: 0;
				width: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				color: #7D8290;
				font-size: 14px;
				z-index: 44;
				padding: 16px 0;
				img {
					width: 7px;
					margin-left: 5px;
				}
			}

		}
		.login_icon img {
			margin: 0 auto;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/user/ticket/Ticket.vue